<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isDDMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 450px;">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["R"]["CSL"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_isDDMV = false">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div class="text-right">
                                        <CButton class="mb-1 btnReset" @click="resetColumn()" v-if="needResetHeaders">
                                            <span class="font-weight-bold cil-reload"></span>
                                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                                        </CButton>
                                    </div>

                                    <draggable v-model="reportHeaders" tag="ul" class="p-0 mb-0 sorttable">
                                        <li v-for="header in reportHeaders" :key="header" scope="col" class="list-group-item p-2">
                                            <template v-if="header == 'NO'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['GL']['NO']}}
                                            </template>
                                            <template v-else-if="header == 'CHECKBOX' && checkModuleAccess2(constAccessType.edit)">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                <div class="d-inline-block" v-if="checkModuleAccess2(constAccessType.edit) && isSENS == 0"><input type="checkbox" class="checkBox15" v-model="checkAll" @change="selectAll()"></div>
                                                <div class="d-inline-block" v-if="checkModuleAccess2(constAccessType.edit) && isSENS == 1"></div>
                                            </template>
                                            <template v-else-if="header == 'AGI'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['GL']['AGT']}}
                                                <i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'U'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['U']}}
                                                <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'BI'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['BI']}}
                                            </template>
                                            <template v-else-if="header == 'BR'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['BR']}}
                                                <i @click="setSortTable('BR')" :class="setSortLogo('BR')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'BB'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['BB']}}
                                                <i @click="setSortTable('BB')" :class="setSortLogo('BB')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'BTS'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['BTS']}}
                                                <i @click="setSortTable('BTS')" :class="setSortLogo('BTS')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'RS'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage['MEM']['RS']}}
                                            </template>
                                        </li>
                                    </draggable>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage['SMB']['BLL']}}</h2>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ACT']}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_Mode"
                                            :clearable="false"
                                            v-model="mode" />
                            </div>
                            <div class='searchCol' v-if="getUserInfo.AT !== 4">
                                <span class='searchLabel'>{{this.getLanguage['GL']['AGT']}} :</span>
                                <customtreeselect :multiple="false"
                                                  :load-options="loadAgentOptions"
                                                  :options="ddAgentList"
                                                  :auto-load-root-options="convertToBool(searchAgent)"
                                                  :defaultExpandLevel="Infinity"
                                                  :disable-branch-nodes="true"
                                                  @input="selectAgentOptions"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  v-model="searchAgent" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SAGT"]}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :key="rtSubBrand"
                                            :load-options="loadSubBrandOptions"
                                            :cacheOptions="false"
                                            :options="ddSubAgentList"
                                            :defaultOptions="ddDefaultSubBrand"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('GL.SAGT')"
                                            v-model="searchSubAgent"
                                            openDirection="below"
                                            @input="selectSubAgentOptions" />

                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['MEM']['U']}} :</span>
                                <treeselect :multiple="false"
                                            :async="true"
                                            :cacheOptions="false"
                                            :load-options="loadMemberOptions"
                                            :options="ddMemberList"
                                            :disable-branch-nodes="true"
                                            :searchPromptText="this.getLanguage['GL']['DDTS']"
                                            :placeholder="this.utilGetDDLanguage('MEM.U')"
                                            v-model="searchUsername" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="searchBlacklistDtRange"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchBlacklistDtRange.startDate != ''">
                                            <CInput size="sm"
                                                    :value="searchBlacklistDtRange.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   :opens="getUserInfo.AT !== 4  ? 'right' : 'left'"
                                                   :auto-apply="true"
                                                   v-model="searchBlacklistDtRange"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="searchBlacklistDtRange.endDate != ''">
                                            <CInput size="sm"
                                                    :value="searchBlacklistDtRange.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol' v-if="mode == '1'">
                                <span class='searchLabel'>{{this.getLanguage['MEM']['RR']}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_rejectreason"
                                            :placeholder="getLanguage['MEM']['RR']"
                                            v-model="searchRR"
                                            :limit="1"
                                            :limitText="count => `+${count}`" />
                            </div>
                            <div class='searchCol' v-if="mode == '2'">
                                <span class='searchLabel'>{{this.getLanguage['MEM']['FRR']}} :</span>
                                <treeselect :multiple="false"
                                            :options="dd_rejectreasonF"
                                            :placeholder="getLanguage['MEM']['FRR']"
                                            v-model="searchFRR"
                                            :limit="1"
                                            :limitText="count => `+${count}`" />
                            </div>

                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['MEM']['BR']}} :</span>
                                <CInput vertical
                                        size="sm"
                                        :value="searchRemarks"
                                        @change="v => searchRemarks = v" />
                            </div>

                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['MEM']['BI']}} :</span>
                                <treeselect :multiple="false"
                                            :options="ddBankBrandList"
                                            :placeholder="this.utilGetDDLanguage('MEM.BI')"
                                            v-model="searchBank"
                                            :load-options="loadBankBrandOptions"
                                            :auto-load-root-options="false" />
                            </div>

                            <div class="searchCol">
                                <label class="searchLabel">{{this.getLanguage['MEM']['BA']}} :</label>
                                <CInput size="sm" :value="searchBankAccName"
                                        @change="v => searchBankAccName = v" />
                            </div>

                            <div class="searchCol">
                                <label class="searchLabel">{{this.getLanguage['MEM']['BAN']}} :</label>
                                <CInput size="sm" :value="searchBankAcc"
                                        @change="v => searchBankAcc = v" />
                            </div>

                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['MEM']['BB']}} :</span>
                                <CInput vertical
                                        size="sm"
                                        :value="searchOperator"
                                        @change="v => searchOperator = v" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['MEM']['RU']}} :</span>
                                <CInput vertical
                                        size="sm"
                                        :value="searchReferralName"
                                        @change="v => searchReferralName = v" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" ref="search" @shortkey="newSearch()" class='searchBtn' size="sm" block color="success"
                                     @click="newSearch()">
                                <span class='searchIcon cil-search'>
                                </span><span>{{this.getLanguage['BTN']['SR']}}</span>
                            </CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class='table-wrapper'>
                <header class="table-header">
                    <div>
                        <strong>{{getLanguage['MEM']['BLKL']}}</strong>
                        <CButton size="sm" color="outline-danger" v-if="selected_items!=null && selected_items.length>0" @click="doPostCheckBox()" style="padding:2px;font-size:12px;min-width:60px">
                            <span class="cil-action-undo"></span><span v-if="this.mode==1">{{this.getLanguage['BTN']['UDO']}}&nbsp;</span><span v-else-if="this.mode==2">{{this.getLanguage['BTN']['UFR']}}&nbsp;</span>
                        </CButton>
                    </div>
                    <div class="pageBtn">
                        <CButton class="btnReset" @click="bool_isDDMV = true"><span class="fa-solid fa-up-down"></span>{{this.getLanguage['R']['CS']}}</CButton>
                        <CButton class="btnReset" @click="resetColumn()" v-if="needResetHeaders">
                            <span class="font-weight-bold cil-reload"></span>
                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                        </CButton>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['NO']}}
                                    </template>
                                    <template v-else-if="header == 'CHECKBOX' && checkModuleAccess2(constAccessType.edit)">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        <div class="d-inline-block" v-if="checkModuleAccess2(constAccessType.edit) && isSENS == 0"><input type="checkbox" class="checkBox15" v-model="checkAll" @change="selectAll()"></div>
                                        <div class="d-inline-block" v-if="checkModuleAccess2(constAccessType.edit) && isSENS == 1"></div>
                                    </template>
                                    <template v-else-if="header == 'AGI'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['AGT']}}
                                        <i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'U'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['U']}}
                                        <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BI'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['BI']}}
                                    </template>
                                    <template v-else-if="header == 'BR'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['BR']}}
                                        <i @click="setSortTable('BR')" :class="setSortLogo('BR')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BB'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['BB']}}
                                        <i @click="setSortTable('BB')" :class="setSortLogo('BB')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['BTS']}}
                                        <i @click="setSortTable('BTS')" :class="setSortLogo('BTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'RS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['RS']}}
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['NO']}}
                                    </template>
                                    <template v-else-if="header == 'CHECKBOX' && checkModuleAccess2(constAccessType.edit)">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        <div class="d-inline-block" v-if="checkModuleAccess2(constAccessType.edit) && isSENS == 0"><input type="checkbox" class="checkBox15" v-model="checkAll" @change="selectAll()"></div>
                                        <div class="d-inline-block" v-if="checkModuleAccess2(constAccessType.edit) && isSENS == 1"></div>
                                    </template>
                                    <template v-else-if="header == 'AGI'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['GL']['AGT']}}
                                        <i @click="setSortTable('AGN')" :class="setSortLogo('AGN')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'U'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['U']}}
                                        <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BI'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['BI']}}
                                    </template>
                                    <template v-else-if="header == 'BR'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['BR']}}
                                        <i @click="setSortTable('BR')" :class="setSortLogo('BR')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BB'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['BB']}}
                                        <i @click="setSortTable('BB')" :class="setSortLogo('BB')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'BTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['BTS']}}
                                        <i @click="setSortTable('BTS')" :class="setSortLogo('BTS')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'RS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage['MEM']['RS']}}
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if="!arr_MemberList || arr_MemberList.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arr_MemberList" :class="data.RS == 1? 'blacklist-row': data.RS == 3? 'freeze-row': ''">
                            <td v-for="header in reportHeaders" :key="header">
                                <template v-if="header == 'NO'">
                                    {{ CountItem(index+1) }}
                                </template>
                                <template v-else-if="header == 'CHECKBOX' && checkModuleAccess2(constAccessType.edit)">
                                    <span id="actionBtnCol" v-if="checkModuleAccess2(constAccessType.edit) && isSENS == 1 && data.AGI == curAGI">
                                        <div class="custom_tooltip" v-if="data.RS == 1">
                                            <span class="grid-line">
                                                <i class="cil-action-undo" @click='unBlacklistMember(data)'></i> <!--here Remove -->
                                                <span class="tooltiptext">{{getLanguage["BTN"]["UDO"]}}</span>
                                                &nbsp;
                                                <input class="checkBox15" v-model="selected_items" type="checkbox" :id="data.I" :value="data.I +'#'+ data.UTS+'#'+data.AGI" number />
                                            </span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.RS == 3">
                                            <span class="grid-line">
                                                <i class="cil-action-undo" @click='unFreezeMember(data)'></i> <!--here Freeze -->
                                                <span class="tooltiptext">{{getLanguage["BTN"]["UFR"]}}</span>
                                                &nbsp;
                                                <span class="float-right chkPadding">
                                                    <input class="checkBox15" v-model="selected_items" type="checkbox" :id="data.I" :value="data.I +'#'+ data.UTS+'#'+data.AGI" number />
                                                </span>
                                            </span>
                                        </div>
                                    </span>
                                    <span id="actionBtnCol" v-else-if="checkModuleAccess2(constAccessType.edit) && isSENS == 1 && data.AGI != curAGI">
                                        <div class="custom_tooltip" v-if="data.RS == 1">
                                            <span class="grid-line">
                                                <i class="cil-action-undo"></i> <!--here Remove -->
                                                <span class="tooltiptext">{{getLanguage["BTN"]["UDO"]}}</span>
                                                &nbsp;
                                            </span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.RS == 3">
                                            <span class="grid-line">
                                                <i class="cil-action-undo"></i> <!--here Freeze -->
                                                <span class="tooltiptext">{{getLanguage["BTN"]["UFR"]}}</span>
                                                &nbsp;
                                                <span class="float-right chkPadding">
                                                </span>
                                            </span>
                                        </div>
                                    </span>
                                    <span id="actionBtnCol" v-else-if="checkModuleAccess2(constAccessType.edit)">
                                        <div class="custom_tooltip" v-if="data.RS == 1">
                                            <span class="grid-line">
                                                <i class="cil-action-undo" @click='unBlacklistMember(data)'></i> <!--here Remove -->
                                                <span class="tooltiptext">{{getLanguage["BTN"]["UDO"]}}</span>
                                                &nbsp;
                                                <input class="checkBox15" v-model="selected_items" type="checkbox" :id="data.I" :value="data.I +'#'+ data.UTS+'#'+data.AGI" number />
                                            </span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.RS == 3">
                                            <span class="grid-line">
                                                <i class="cil-action-undo" @click='unFreezeMember(data)'></i> <!--here Freeze -->
                                                <span class="tooltiptext">{{getLanguage["BTN"]["UFR"]}}</span>
                                                &nbsp;
                                                <span class="float-right chkPadding">
                                                    <input class="checkBox15" v-model="selected_items" type="checkbox" :id="data.I" :value="data.I +'#'+ data.UTS+'#'+data.AGI" number />
                                                </span>
                                            </span>
                                        </div>
                                    </span>
                                </template>
                                <template v-else-if="header == 'AGI'">
                                    <span class="grid-line">{{ data.AGN }}</span>
                                    <span class="saggroupname">{{ data.SAGN }}</span>
                                    <span class="grid-line">{{ data.DMN }}</span>
                                </template>
                                <template v-else-if="header == 'U'">
                                    <div class="custom_tooltip">
                                        <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                        <span v-if="convertToBool(data.TN)" class="tooltiptext tooltip-right" :style="getbgtooltip(data)">{{data.TN}}</span>
                                    </div>
                                    <div class="custom_tooltip" v-if="data.TW == 0">
                                        <img src="/src/assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                        <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["MNM"]}}</span>
                                    </div>
                                    <div class="custom_tooltip" v-if="data.HTWT">
                                        <img src="/src/assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                        <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["PVP"]}}</span>
                                    </div>
                                    <div class="custom_tooltip" v-if="data.RP">
                                        <img src="/src/assets/icons/referral.svg" class="referral-icon" />
                                        <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["RFB"]}}</span>
                                    </div>
                                </template>
                                <template v-else-if="header == 'BI'">
                                    <div v-for="(ydata,yindex) in data.BankList">
                                        <div class="custom_tooltip">
                                            <span :class="ydata.RS == 1 ? 'blacklist-row': ydata.RS == 3 ? 'freeze-row' : ydata.RS == 4 ? 'warninglist-row' : ydata.IB ? 'highrisk-row':''">{{ HideInfo(HideBankInfo, ydata.BA, 4) }} ({{ ydata.BNM }}) - {{ HideInfo(HideBankInfo, ydata.BAN, 4) }}</span>
                                            <span v-if="getUserInfo.AT == 0 && ydata.DBAC > 1">({{ ydata.DBAC }})</span>
                                            <span v-if="ydata.IB && ydata.RS==2" class="tooltiptext" style="background:red">{{getLanguage['BANK']['SBA']}}</span>
                                        </div>
                                        <div class="float-left mr-1 custom_tooltip pointer" v-if="ydata.RS == 1 && getUserInfo.AT == 0 && checkModuleAccess2(constAccessType.edit)" @click='unBlockMemberBank(ydata, data.AGI, data.I)'>
                                            <i class="fa-solid fa-lock-open" style="color: rgb(201, 84, 90)"></i>
                                            <span class="tooltiptext" style="background:red">{{getLanguage['BTN']['UDO']}}</span>
                                        </div>
                                    </div>
                                </template>
                                <template v-else-if="header == 'BR'">
                                    {{ renderBlackListReason(data.BR) }}
                                </template>
                                <template v-else-if="header == 'BB'">
                                    {{ data.BB }}
                                </template>
                                <template v-else-if="header == 'BTS'">
                                    {{ formatDateTime(data.BTS,"YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}
                                </template>
                                <template v-else-if="header == 'RS'">
                                    <span v-if="data.RS == 1">{{ getLanguage['GL']['BLK']}}</span>
                                    <span v-if="data.RS == 3">{{ getLanguage['GL']['FZ']}}</span>
                                </template>
                            </td>

                        </tr>
                        </tbody>

                    </table>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import Loading from 'vue-loading-overlay';
    import moment from "moment";
    import 'vue-loading-overlay/dist/vue-loading.css';
    import genericHelper from "@/modules/GenericHelper.js";
    import { mapGetters, mapActions } from 'vuex';
    import { constAccessType, constRejectReasonBL, constRejectReasonF, constBlackListFreezeListMode, loadingFullScreen } from '@/modules/Constant.js'
    import Vue from 'vue'
    import $ from 'jquery'
    //Vue.use(require('vue-shortkey'))
    import draggable from 'vuedraggable';

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
            draggable
        },
        data() {
            return {
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                str_tableSortBy: "I", //(sort the table col name)
                bool_isSort: false, // Table Ascending Descending
                bool_showSearchBar: true,
                // dropdown value
                ddAgentList: null,
                ddSubAgentList: null,
                ddBankBrandList: null,
                ddDefaultSubBrand: null,
                rtSubBrand: 0,
                // search fields
                searchAgent: null,
                searchSubAgent: null,
                searchUsername: null,
                searchBank: null,
                searchBankAccName: null,
                searchBankAcc: null,
                searchRemarks: null,
                searchOperator: null,
                searchReferralName: null,
                searchRR: null,
                searchFRR: null,
                searchBlacklistDtRange: { startDate: "", endDate: "" },
                arr_MemberList: [],
                selected_items: [],
                dd_rejectreason: [],
                dd_rejectreasonF: [],
                ddMemberList: [],
                dd_Mode: [],
                mode: "1",
                checkAll: false,
                HideBankInfo: false,
                constAccessType: constAccessType,
                defaultReportHeaders: ['NO', 'CHECKBOX', 'AGI', 'U', 'BI', 'BR', 'BB', 'BTS', 'RS'],
                reportHeaders: [],
                needResetHeaders: false,
                bool_isDDMV: false,
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkModuleAccess', 'getUserMemberSC']),
        },
        created() {
            this.reportHeaders = null;
            this.$parent.showSubMenu = 'M';
            this.$parent.showActiveMenu = 'M.BLL';

            if (this.getUserInfo.AT == 4)
                this.loadDefaultSubBrand(0);
            else
                this.getBlacklistMemberList();

            //this.dd_rejectreason = constRejectReasonBL;
            //this.dd_rejectreasonF = constRejectReasonF;
            //this.dd_Mode = constBlackListFreezeListMode;
            this.getMode();
            this.getRejectReason();
            this.getRejectReasonF();
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;

            this.HideBankInfo = this.getUserInfo.IHMI;
        },
        methods: {
            ...mapActions('UserInfo', ['setSearchCriteriaAGI']),
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchBlacklistDtRange.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.searchBlacklistDtRange.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.searchBlacklistDtRange.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.searchBlacklistDtRange.endDate = "";
                    }
                }
            },
            setSortTable(SV) {
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getBlacklistMemberList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            ctrPage(newPage, inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getBlacklistMemberList();
            },
            newSearch() {
                this.$refs.search.focus();
                this.int_Page = 1;
                this.int_IC = 1;
                this.getBlacklistMemberList();
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            selectAgentOptions(value, instanceId) {
                this.searchSubAgent = null;
                if (value) {
                    this.setSearchCriteriaAGI(value);
                }
                else {
                    this.setSearchCriteriaAGI(null);
                }

                this.ddBankBrandList = null;
                this.searchBank = null;
            },
            selectSubAgentOptions(value, instanceId) {
                if (value) {
                    this.setSearchCriteriaAGI('4-' + value);
                }
                else {
                    this.setSearchCriteriaAGI(null);
                }

                this.ddBankBrandList = null;
                this.searchBank = null;
            },
            loadMemberOptions({ action, searchQuery, callback }) {
                var that = this;
                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMemberList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    var agi = 0;
                    if (this.searchSubAgent) {
                        agi = this.searchSubAgent;
                    } else if (this.searchAgent) {
                        agi = this.searchAgent.split("-")[1];
                    }
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${agi}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberList = d.dropdownlist;
                            }
                            else {
                                that.ddMemberList = [];
                            }

                            callback(null, that.ddMemberList);
                        });
                }
            },
            loadSubBrandOptions({ action, searchQuery, callback }) {
                var that = this;
                var parentAGI = 0;
                if (this.searchAgent) {
                    var agentList = this.searchAgent.split("-");
                    parentAGI = agentList[agentList.length - 1];
                }
                else if (this.getUserInfo.AT === 4) {
                    parentAGI = 0;
                }
                else {
                    this.ddSubAgentList = [];
                    callback(this.getLanguage['MEM']['PSAA']);
                }

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddSubAgentList = [];
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${parentAGI}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddSubAgentList = d.dropdownlist;
                                //that.bool_cacheOptionValue = true;
                            }
                            else {
                                that.ddSubAgentList = [];
                            }
                            callback(null, that.ddSubAgentList);
                        });
                }
            },
            loadAgentOptions({ action, callback, instanceId }) {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddAgentList = d.dropdownlist;
                        }
                        else {
                            that.ddAgentList = null;
                        }

                        callback();
                    });
            },
            loadBankBrandOptions({ action, callback, instanceId }) {
                var that = this;
                if (!this.searchAgent) {
                    callback(this.getLanguage['MEM']['PSAA']);
                }
                else {
                    var agentList = this.searchAgent.split("-");
                    this.getDataApi(`/api/dd/mbank/${agentList[agentList.length - 1]}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddBankBrandList = d.dropdownlist;
                            }
                            else {
                                that.ddBankBrandList = null;
                            }

                            callback();
                        });
                }
            },
            loadDefaultSubBrand(agi) {
                var that = this;
                var searchQuery = "0";

                this.getDataApi(`/api/dd/subbrand/0/${searchQuery}/${agi}`,
                    function (d, s) {
                        if (s && d && d.dropdownlist) {
                            that.ddDefaultSubBrand = d.dropdownlist;
                            that.searchSubAgent = that.ddDefaultSubBrand[0].id;
                            that.rtSubBrand = that.rtSubBrand == 0 ? 1 : 0;
                        }
                        else {
                            that.ddDefaultSubBrand = [];
                        }
                        that.getBlacklistMemberList();
                    });
            },
            getBlacklistMemberList() {
                this.bool_fullLoading = true;
                var that = this;
                var agentGId = null;

                if (this.searchAgent) {
                    var agentList = this.searchAgent.split("-");
                    agentGId = agentList[agentList.length - 1];
                }

                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                var hasDefaultPath = false;

                if (path) {
                    hasDefaultPath = true;
                }

                //if (agentGId) {
                //    path += "&f.AGI=" + agentGId;
                //}
                if (this.searchSubAgent) {
                    path += "&f.AGI=" + this.searchSubAgent;
                } else if (agentGId) {
                    path += "&f.AGI=" + agentGId;
                }

                if (this.searchUsername) {
                    path += "&f.MI=" + this.searchUsername;
                }

                if (this.searchBank) {
                    path += "&f.BS=" + this.searchBank;
                }

                if (this.searchBankAccName) {
                    path += "&f.BAN=" + this.searchBankAccName;
                }

                if (this.searchBankAcc) {
                    path += "&f.BANUM=" + this.searchBankAcc;
                }

                if (this.searchOperator) {
                    path += "&f.BB=" + this.searchOperator;
                }

                if (this.searchReferralName) {
                    path += "&f.RU=" + this.searchReferralName;
                }

                if (this.mode == null)
                    this.mode = 1;
                //debugger
                if (this.mode == "1") {
                    if (this.searchBlacklistDtRange) {
                        if (this.searchBlacklistDtRange.startDate != "") {
                            path += "&f.BTS_from=" + this.parseDateToJsonString(this.searchBlacklistDtRange.startDate);
                        }

                        if (this.searchBlacklistDtRange.endDate != "") {
                            path += "&f.BTS_to=" + this.parseDateToJsonString(this.searchBlacklistDtRange.endDate);
                        }
                    }

                    if (this.searchRemarks) {
                        path += "&f.BR=" + this.searchRemarks;
                    }

                    if (this.searchRR) {
                        path += "&f.BR=" + this.searchRR;
                    }

                    if (!hasDefaultPath && path) {
                        path = path.substring(1);
                    }

                    this.getDataApi(`/api/m/bl?${path}`,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                that.int_TP = Math.max(d.D.TotalPages, 1);
                                that.int_Total = d.D.TotalItems;
                                that.arr_MemberList = d.D.Items;
                                that.selected_items = [];
                                that.resizeTableHead();
                            }
                        });
                }
                else if (this.mode == "2") {
                    if (this.searchBlacklistDtRange) {
                        if (this.searchBlacklistDtRange.startDate != "") {
                            path += "&f.FTS_from=" + this.parseDateToJsonString(this.searchBlacklistDtRange.startDate);
                        }

                        if (this.searchBlacklistDtRange.endDate != "") {
                            path += "&f.FTS_to=" + this.parseDateToJsonString(this.searchBlacklistDtRange.endDate);
                        }
                    }

                    if (this.searchRemarks) {
                        path += "&f.FR=" + this.searchRemarks;
                    }

                    if (this.searchFRR) {
                        path += "&f.FR=" + this.searchFRR;
                    }

                    if (!hasDefaultPath && path) {
                        path = path.substring(1);
                    }

                    this.getDataApi(`/api/m/fl?${path}`,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            if (s) {
                                that.int_TP = Math.max(d.D.TotalPages, 1);
                                that.int_Total = d.D.TotalItems;
                                that.arr_MemberList = d.D.Items;
                                that.selected_items = [];
                                that.resizeTableHead();
                            }
                        });
                }
            },
            renderBlackListReason(blackListReason) {
                const found = constRejectReasonBL.some(el => el.id === blackListReason);
                if (found) {
                    blackListReason = this.dd_rejectreason[blackListReason - 1].label;
                }
                return blackListReason;
                //const found = constRejectReasonBL.some(el => el.id === blackListReason);

                //if (found) {
                //    for (var d of constRejectReasonBL) {
                //        if (d.id == blackListReason) {
                //            blackListReason = d.label;
                //        }
                //    }
                //}

                //return blackListReason;
            },
            unBlacklistMember(d) {
                this.$fire({
                    title: this.getLanguage["MEM"]["CUBLK"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: d.I,
                            uts: d.UTS,
                            agi: d.AGI
                        };

                        this.postDataApi(`/api/m/ubm`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.getBlacklistMemberList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            unFreezeMember(d) {
                this.$fire({
                    title: this.getLanguage["MEM"]["CUF"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            i: d.I,
                            uts: d.UTS,
                            agi: d.AGI
                        };

                        this.postDataApi(`/api/m/ufm`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.getBlacklistMemberList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            unBlockMemberBank(d, AGI, MI) {
                this.$fire({
                    title: this.getLanguage["MEM"]["CUBA"],
                    html: this.HideInfo(this.HideBankInfo, d.BA, 4) + " (" + d.BNM + ") - " + this.HideInfo(this.HideBankInfo, d.BAN, 4),
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var dt = {
                            MI: MI,
                            BAN: d.BAN,
                            AGI: AGI
                        };

                        this.postDataApi(`/api/m/ubmba`, dt,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.getBlacklistMemberList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            doPostCheckBox() {
                if (this.mode == null) {
                    this.mode = 1;
                }
                if (this.mode == "1") { //un blacklist
                    this.$fire({
                        title: this.getLanguage["MEM"]["CUBLKS"],
                        width: '30em',
                        showCancelButton: true,
                        confirmButtonText: this.getLanguage["GL"]["YES"],
                        cancelButtonText: this.getLanguage["CNO"]["NO"],
                        reverseButtons: true,
                        customClass: {
                            title: 'afb-alert-title',
                            content: 'afb-alert-content',
                            actions: 'afb-alert-action'
                        }
                    }).then((result) => {
                        if (result.value == true) {
                            this.bool_fullLoading = true;
                            var that = this;

                            this.postDataApi(`/api/m/ubmbcb`, this.selected_items,
                                function (d, s) {
                                    that.bool_fullLoading = false;

                                    if (s) {
                                        that.getBlacklistMemberList();
                                        that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                    }
                                });
                        }
                    });
                }
                else if (this.mode == "2") { //un freeze

                    this.$fire({
                        title: this.getLanguage["MEM"]["CUFS"],
                        width: '30em',
                        showCancelButton: true,
                        confirmButtonText: this.getLanguage["GL"]["YES"],
                        cancelButtonText: this.getLanguage["CNO"]["NO"],
                        reverseButtons: true,
                        customClass: {
                            title: 'afb-alert-title',
                            content: 'afb-alert-content',
                            actions: 'afb-alert-action'
                        }
                    }).then((result) => {
                        if (result.value == true) {
                            this.bool_fullLoading = true;
                            var that = this;

                            this.postDataApi(`/api/m/ufmbcb`, this.selected_items,
                                function (d, s) {
                                    that.bool_fullLoading = false;

                                    if (s) {
                                        that.getBlacklistMemberList();
                                        that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                    }
                                });
                        }
                    });
                }
            },
            selectAll() {
                this.selected_items = [];
                if (this.checkAll) {
                    this.arr_MemberList.forEach((value, key) => {
                        this.selected_items.push(value.I + '#' + value.UTS + '#' + value.AGI);

                    });
                }
            },
            clearDateRangeFilter() {
                this.searchBlacklistDtRange = {
                    startDate: "",
                    endDate: ""
                };
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('BLL', 'M', type);
            },
            resetColumn(headerName) {
                var that = this;
                for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                    that.$set(that.reportHeaders, i, that.defaultReportHeaders[i])
                }
                this.resizeTableHead();
            },
            removeColumn(headerName) {
                var that = this;
                const index = that.reportHeaders.indexOf(headerName);
                if (index > -1)
                    that.reportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            removeDefaultColumn(headerName) {
                var that = this;
                const index = that.defaultReportHeaders.indexOf(headerName);
                if (index > -1)
                    that.defaultReportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            getbgtooltip(data) {
                var bgColor = '#FFF';
                var textColor = '#000';
                if (data) {
                    if (data.TBC) {
                        bgColor = data.TBC;
                    }

                    if (data.TC) {
                        textColor = data.TC;
                    }
                }
                return {
                    backgroundColor: bgColor, color: textColor, padding: '0px 5px', borderRadius: '5px'
                };
            },
            getMode() {
                this.dd_Mode = [{ id: "1", label: this.getLanguage['MEM']['BL'] }, { id: "2", label: this.getLanguage['MEM']['FL'] }]
            },
            getRejectReasonF() {
                this.dd_rejectreasonF = [{ id: "1", label: this.getLanguage['MEM']['SIMA'] }, { id: "2", label: this.getLanguage['MEM']['HCD'] },
                { id: "3", label: this.getLanguage['MEM']['SAA'] }, { id: "4", label: this.getLanguage['MEM']['IM'] }, { id: "999", label: this.getLanguage['BETRPT']['OTR'] }];
            },
            getRejectReason() {
                this.dd_rejectreason = [{ id: "1", label: this.getLanguage['MEM']['SIMA'] }, { id: "2", label: this.getLanguage['MEM']['HCD'] },
                { id: "3", label: this.getLanguage['MEM']['SAA'] }, { id: "4", label: this.getLanguage['MEM']['IM'] }, { id: "999", label: this.getLanguage['BETRPT']['OTR'] }];
            }

        },
        watch: {
            getLanguage() {
                this.getBlacklistMemberList();
                this.getMode();
                this.getRejectReason();
                this.getRejectReasonF();
            },
            reportHeaders() {
                var that = this;
                if (this.reportHeaders == null) {
                    this.getDataApi(`/api/reports/gc/MemberBlackList`,
                        function (d, s) {
                            if (s) {
                                if (d == null) {
                                    that.reportHeaders = [];
                                    for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                                        if (that.reportHeaders.indexOf(that.defaultReportHeaders[i]) == -1)
                                            that.reportHeaders.push(that.defaultReportHeaders[i]);
                                    }
                                }
                                else
                                    try {
                                        that.reportHeaders = JSON.parse(d);
                                    } catch (e) {
                                        d += "]";
                                        that.reportHeaders = JSON.parse(d);
                                    }

                                // hide columns for unauthorized access users
                                if (!(that.checkModuleAccess2(constAccessType.edit))) {
                                    that.removeDefaultColumn('CHECKBOX');
                                    that.removeColumn('CHECKBOX');
                                }
                            }
                        });
                }
                else {
                    this.getDataApi(`/api/reports/sc/MemberBlackList/` + JSON.stringify(that.reportHeaders),
                        function (d, s) {
                            if (s) {

                            }
                        });
                }

                if (this.reportHeaders != null) {
                    if (that.defaultReportHeaders.length != that.reportHeaders.length)
                        that.needResetHeaders = true;
                    else
                        that.needResetHeaders = false;
                }
            }
        },
    }
</script>
<style>
    .checkBox15 {
        width: 15px;
        height: 15px;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Member/BlackList.vue